
import {map} from 'rxjs/operators';
import { Component, Input, OnInit, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";


import { EditEntityComponent } from "./edit-entity.component";

import { ComponentService, serviceObj } from "../../services/component-service.service";
import { DialogService } from "../../../common/services/dialog.service";
import { EntityBuilderService } from "../../../builder/services/entity-builder.service";
import { LoaderService } from "../../../common/services/loader.service";
import { SidePanelService } from "../../../common/services/side-panel.service";
import { SubHeaderService } from "../../../core/services/sub-header.service";

import { EbComponentHostDirective } from "../../directives/ebcomponent-host.directive";

import { EntityBuilderItem } from "../../models/entity-builder-item";
import { LunaEntity } from "../../../builder/models/entity.model";
import { SubHeader } from "../../../core/models/sub-header.model";
import { SidePanel } from "../../../common/models/side-panel.model";
import { GroupService, GroupSearchSpec } from '../../../admin/services/group.service';
import { Subscription } from 'rxjs';
import { GroupStub } from '../../../admin/models/group.model';
import { omit, setPropertyValue, mapKeys, isEqual } from "../../../common/models/data-manipulation-functions";

@Component({
    selector: "entitybuilder",
    templateUrl: "./entitybuilder.component.html",
    styleUrls: ["./entitybuilder.component.scss"],
    standalone: false
})
export class EntityBuilderComponent implements OnInit, OnDestroy {
    public entity: LunaEntity;
    public editing: any;
    public subHeader = new SubHeader({ title: "Entity Builder", buttons: [{ name: "Save", method: () => this.save() }, { name: "Cancel", method: () => this.cancel() }] });
    public sidePanel: SidePanel = new SidePanel({
    tabs: [{ title: "Entity Builder" }],
    sections: [{ componentName: "EditEntity", method: (obj) => this.saveAddEdit(obj), componentData: { name: "", data: {}, parent: "" } }],
    visible: false
    });
    public name: string;
    public data: any;
    public parent: string;
    public groups: GroupStub[]
    private subscriptions: Subscription = new Subscription();

    @ViewChild(EditEntityComponent) editEntity: EditEntityComponent;
    @ViewChild(EbComponentHostDirective, { static: true }) ebComponentHost: EbComponentHostDirective;

  constructor(
    public readonly subHeaderService: SubHeaderService,
    public route: ActivatedRoute,
    public ebService: EntityBuilderService,
    public loaderService: LoaderService,
    public dialogService: DialogService,
    public router: Router,
    public componentFactoryResolver: ComponentFactoryResolver,
    public componentService: ComponentService,
    public ebComponentItem: EntityBuilderItem,
    public sidePanelService: SidePanelService,
    public groupService: GroupService
  ) {
      this.subscriptions.add(componentService.deleteAnnounced$.subscribe((deleting) => {
          this.deleteObject(deleting.name, deleting.data, deleting.parent);
        },
        (error) => { console.log(error) }));

      this.subscriptions.add(componentService.editAnnounced$.subscribe((editing) => {
          this.editObject(false, editing.name, editing.data, editing.parent);
        },
        (error) => { console.log(error) }));

      this.subscriptions.add(componentService.addAnnounced$.subscribe((adding) => {
          this.editing = adding;
          this.editObject(true, adding.name, adding.data, adding.parent);
        },
        (error) => { console.log(error) }));
    }

    ngOnInit() {
        this.subscriptions.add(this.route.data.pipe(map(data => data.entity)).subscribe(results => {
            this.entity = results;
        },
            (error) => { console.log(error) }));

        this.subscriptions.add(this.groupService.get({ internal: true, stubs: true } as GroupSearchSpec).pipe().subscribe(results => {
            this.groups = results as GroupStub[];
            this.loaderService.toggleLoader(false);
        },
        (error) => {
            console.log(error)
                this.loaderService.toggleLoader(false);
        }));

        this.buildModel(this.entity.schemaObject);

        this.subHeaderService.updateSubHeader(this.subHeader);
    }


  ngOnDestroy() {
       if (this.subscriptions) this.subscriptions.unsubscribe();
  }

  public save() {
    this.dialogService.openDialog("yesNo", `Are you sure you want to save ${this.entity.entityName}?`, "saveEntity");
  }

    public edit() {
        this.entity.entityName = this.entity.schemaObject.title;
        this.editObject(false, this.entity.schemaObject.title, this.entity.schemaObject, "root");
    }

  public add() {
    const addItem: any = {
      name: "",
      data: { type: "object" },
      parent: "properties",
      newItem: true
    }
    this.sidePanelService.newSidePanel(this.sidePanel);
    this.sidePanelService.updateSectionData("EditEntity", addItem);
    this.sidePanelService.toggleSidePanel(true);
  }

  public cancel() {
    this.dialogService.openDialog("yesNo", `Are you sure you want to cancel changes to ${this.entity.entityName}?<br> All changes will not be saved.`, "cancelEntity");
  }

  public buildModel(schema) {
    Object.keys(schema.properties).forEach(key => {
      this.loadComponent(key, schema.properties[key]);
    });
  }

  public loadComponent(propName: string, prop) {
    this.ebComponentItem.createComponent(prop, false, prop);
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.ebComponentItem.component);
    let viewContainerRef = this.ebComponentHost.viewContainerRef;

	  //let componentRef = viewContainerRef.createComponent(componentFactory);
	  let componentRef = viewContainerRef.createComponent(this.ebComponentItem.component);
    (<IEbComponent>componentRef.instance).data = this.ebComponentItem.data;
    (<IEbComponent>componentRef.instance).title = propName;
    (<IEbComponent>componentRef.instance).parent = "properties";
  }

  public editObject(isAdd: boolean, name: string, data: any, parent?: string): void {
    const editing: any = {
      name: name,
      data: data,
      parent: parent,
      newItem: isAdd
    };

    this.sidePanelService.newSidePanel(this.sidePanel);
    this.sidePanelService.updateSectionData("EditEntity", editing);
    this.sidePanelService.toggleSidePanel(true);
  }

  public saveAddEdit(obj): void {
    if(obj.type == "add") {
      this.saveAdd(obj.data);
    } else if (obj.type == "edit") {
      this.saveEdit(obj.data);
    }
  }

  public saveEdit(object: { name: string, data: any, parent?: string, oldName?: string }): void {
    this.recurSave(this.entity.schemaObject, object.name, object.data, object.parent, object.oldName);
    this.ebComponentHost.viewContainerRef.clear();
    this.buildModel(this.entity.schemaObject);
    this.sidePanelService.toggleSidePanel(false);
  }

  public saveAdd(object: { name: string, data: any, parent?: string}): void {
    this.addObject(this.entity.schemaObject, object.name, object.data, object.parent);
    this.ebComponentHost.viewContainerRef.clear();
    this.buildModel(this.entity.schemaObject);
    this.sidePanelService.toggleSidePanel(false);
  }

  public addObject(obj: any, name: string, data: any, parent?:string): void {
    if (data.type === "object") {
      data.properties = {};
    }
    if (data.type === "array" && data.items) {
      setPropertyValue(obj, parent, data.items);
    } else {
      setPropertyValue(obj, parent + "." + name, data);
    }
  }

  public deleteObject(name: string, data: any, parent?:string): void {
    this.name = name;
    this.data = data;
    this.parent = parent;
    this.dialogService.openDialog("yesNo", `Are you sure you want to delete the item "<b>${name}</b>"?<br> The entire item will be deleted.`, "deleteObject");
  }

  public recurDelete(obj: any, name: string, data: any, parent?:string): void {
    if (isEqual(obj[name], data) && (!parent || parent in obj)) {
      delete obj[name];
    }
    else if (obj.properties) {
      if (isEqual(obj.properties[name], data) && (!parent || parent in obj)) {
        delete obj.properties[name];
      } else {
        Object.keys(obj.properties).forEach(key => {
          if (obj.properties[key].properties) {
            this.recurDelete(obj.properties[key].properties, name, data);
          } else {
            return;
          }
        });
      }
    }
  }

  public recurSave(obj: any, name: string, data: any, parent?: string, objOldName?: string): any {
    if (parent === "root") {
      obj.title = name;
      return obj;
    }
    if (isEqual(obj[objOldName], data) && (!parent || parent in obj)) {
      if (objOldName) {
        obj = mapKeys(obj,
          (value, key) => {
            if (key === objOldName) {
              return name;
            } else { return key }
          });
        return obj;
      } else { return obj }
    }
    else if (obj.properties) {
      if (isEqual(obj.properties[objOldName], data) && (!parent || parent in obj)) {
        if (objOldName) {
          obj.properties = mapKeys(obj.properties,
            (value, key) => {
              if (key === objOldName) {
                return name;
              } else { return key }
            });
          return obj;
        } else { return obj }
      } else {
        Object.keys(obj.properties).forEach(key => {
          if (obj.properties[key].properties) {
            obj.properties[key].properties = this.recurSave(obj.properties[key].properties, name, data, null, objOldName);
          } else {
            obj.properties[key] = this.recurSave(obj.properties[key], name, data, null, objOldName);
          }
        });
      }
    } else if (obj.items && obj.items.properties) {
          if (isEqual(obj.items.properties[objOldName], data) && (!parent || parent in obj)) {
              if (objOldName) {
                  obj.items.properties = mapKeys(obj.items.properties,
                      (value, key) => {
                          if (key === objOldName) {
                              return name;
                          } else { return key }
                      });
                  return obj;
              } else { return obj }
          } else {
              Object.keys(obj.items.properties).forEach(key => {
                  if (obj.items.properties[key].properties) {
                      obj.items.properties[key].properties = this.recurSave(obj.items.properties[key].properties, name, data, null, objOldName);
                  } else {
                      obj.items.properties[key] = this.recurSave(obj.items.properties[key], name, data, null, objOldName);
                  }
              });
          }
      } else { return obj };

  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    if (this.dialogService.dialogId === 'saveEntity') {
      this.ebService.post(this.entity).subscribe(entity => {
        this.router.navigate(["/entitybuilder/list"]);
      }, (error) => {
        this.dialogService.openDialog("ok", `There was an error with the schema: ${error}?`, "errorSaving");
      });
    } else if (this.dialogService.dialogId === 'errorSaving') {
      //Do nothing
    } else if (this.dialogService.dialogId === 'cancelEntity') {
      this.router.navigate(["/entitybuilder/list"]);
    } else if (this.dialogService.dialogId === 'deleteObject') {
		this.entity.schemaObject = omit(this.entity.schemaObject, `${this.parent}.${this.name}`);
      //this.recurDelete(this.entity.schemaObject, this.name, this.data, this.parent);
      this.ebComponentHost.viewContainerRef.clear();
      this.buildModel(this.entity.schemaObject);
    }
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}

export interface IEbComponent {
  data: any;
  title: string;
  parent?: string;
  isArray?: boolean;
}
